// The variants are actually imported by the theme, but colocating helps finding them more easily.

const label = {
  fontFamily: 'body',
  fontWeight: 'body',
  textTransform: 'uppercase',
};

export default {
  large: {
    ...label,
    fontSize: 'default',
    lineHeight: 'default',
    letterSpacing: 1,
  },

  default: {
    ...label,
    fontSize: 'smallest',
    lineHeight: 'smallest',
    letterSpacing: 1,
  },

  small: {
    ...label,
    fontSize: 10,
    lineHeight: '16px',
    letterSpacing: 0.8,
  },

  radio: {
    ...label,
    fontSize: 'smallest',
    lineHeight: 'smallest',
    letterSpacing: 'smallest',
  },
};
